<template>
    <v-data-table :headers="headers" :items="processedCars" class="elevation-1 car-table" :loading="loading"
                  :no-data-text="loading ? 'Laster...' : 'Ingen data funnet.'"
                  no-results-text="Ingen resultater funnet."
                  :options.sync="options"
                  :server-items-length="total"
                  :footer-props="footerProps"
                  :items-per-page="100">
        <template v-slot:item="{ item }">
            <car-table-row :customer-id="customerId" :value="item" @save="onCarSave"
                           @click.native="highlightRow(item)"
                           :class="highlightedRow === item ? 'yellow lighten-3' : null"/>
        </template>
    </v-data-table>
</template>

<script>
    import CarTableRow from '../helpers/CarTableRow';
    import {tableOptionsFromRoute, updateRouteFromOptions} from "../../helpers";


    export default {
        name: 'CarTable',
        components: {
            CarTableRow
        },

        props: {
            customerId: Number,
            ignoreFilter: Boolean,
            showDeleted: Boolean,
            invoiceYear: Number
        },

        data() {
            console.log('Page from url:', this.$route.query.page)

            let page = this.$route.query.page;
            if (page) page = parseInt(page, 10);

            return {
                loading: false,
                cars: [],
                meta: null,

                highlightedRow: null
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData(filter = {}) {
                this.loading = true;
                this.cars = [];

                let params = {...this.$route.query, ...filter};
                if(this.ignoreFilter) params = {};
                if(this.showDeleted) params['is_deleted'] = true;
                if(this.invoiceYear) params['invoice_year'] = this.invoiceYear;

                if (this.customerId) {
                    params['customer_id'] = this.customerId;
                }

                this.$http.get('cars', {params}).then(response => {
                    this.cars = response.data.data;
                    this.meta = response.data.meta;
                }).finally(() => {
                    this.loading = false;
                });
            },

            onCarSave() {
                this.loadData();
            },

            highlightRow(row) {
                this.highlightedRow = row;
            }
        },

        watch: {
            options: {
                handler(options) {
                    console.log(options);
                    this.$router.replace({
                        query: {
                            ...this.$route.query,
                            page: options.page || 1,
                            per_page: options.itemsPerPage || 100
                        }
                    });
                    this.loadData();
                },
                deep: true,
            },

            customerId() {
                this.loadData();
            }
        },

        computed: {
            headers() {
                let hs = [
                    {text: 'Bil', value: 'reg_number'},
                    {text: 'Kilometer', value: 'km', sortable: false},
                    {text: 'Kontaktperson', value: 'contact_name'},
                    {text: 'Lokasjon', value: 'location', align: 'center'},
                    {text: 'Merknad', value: 'note'}
                ];

                if (!this.customerId) {
                    hs.push({text: 'Kunde', value: 'customer_name'});
                }

                hs.push({text: 'Leasing', value: 'is_leasing', align: 'center'});

                hs.push({text: `${this.total} biler funnet`, value: 'id', align: 'center', sortable: false});
                return [...hs];
            },

            options: {
                get() {
                    return tableOptionsFromRoute(this.$route);
                },
                set(obj) {
                    updateRouteFromOptions(this.$router, this.$route, obj);
                }
            },

            processedCars() {
                return this.cars.map(car => {
                    let km = null;
                    if (car.current_tire_storages.length > 0) {
                        km = car.current_tire_storages[0].km;
                    }
                    return {
                        ...car,
                        km: km
                    };
                })
            },

            footerProps() {
                return {
                    'items-per-page-text': 'Biler per side:',
                    'items-per-page-options': [100, 200, 500, {text: 'Alle', value: -1}]
                }
            },

            total() {
                if (!this.meta) return 0;
                return this.meta.total;
            }
        }
    }
</script>

<style>
    .contact-phone {
        text-decoration: none;
    }

    .car-title-cell {
        text-decoration: none;
        color: #000;
        line-height: 100%;
        padding: 6px 0 2px 0;
        white-space: nowrap;
    }

    @media print {
        .car-table table thead th:last-child {
            display: none !important;
        }
    }
</style>
